import { datadogRum } from '@/lib/DatadogService';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  ready?: boolean;
  token?: string | null;
  name?: string | null;
  isPm?: boolean;
  isIm?: boolean;
  claimFetched?: boolean;
  refetchClaims?: boolean;
  refetchNav?: boolean;
}

const initialState: AuthState = {
  ready: false,
  token: undefined,
  name: undefined
};

export interface UserState {
  token?: string | null;
  name?: string | null;
  isPm?: boolean;
  isIm?: boolean;
  claimFetched?: boolean;
  individualSk?: string;
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    userLoaded: (state, action: PayloadAction<UserState>) => {
      state.name = action.payload?.name;
      state.token = action.payload?.token;
      state.ready = true;
      window.env.IS_AUTHENTICATED = action.payload?.token ? 'true' : 'false';

      if (action.payload?.individualSk) datadogRum.setUser({ id: action.payload?.individualSk });

      console.info('DIAG:User State loaded ...');
    },
    userClaimsFetched: (state, action: PayloadAction<boolean>) => {
      state.claimFetched = action.payload;
      console.info('DIAG:User Claims fetched ...');
    },
    userRefetchClaims: (state, action: PayloadAction<boolean>) => {
      state.refetchClaims = action.payload;
      console.info('DIAG:Refetching user claims ...');
    },
    userRefetchNav: (state, action: PayloadAction<boolean>) => {
      state.refetchNav = action.payload;
      console.info('DIAG:Refetching user nav ...');
    },
    userLazyClaims: (state, action: PayloadAction<UserState>) => {
      state.isPm = action.payload?.isPm ?? false;
      state.isIm = action.payload?.isIm ?? false;
      console.info('DIAG:User Lazy claims ...');
    },
    userUnloaded: state => {
      state.name = undefined;
      state.token = undefined;
      state.ready = true;
      state.isPm = undefined;
      state.isIm = undefined;
      state.claimFetched = false;
      state.refetchClaims = false;
      state.refetchNav = false;
      window.env.IS_AUTHENTICATED = 'false';
      datadogRum.clearUser();
      console.info('DIAG:User State unloaded ...');
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  userLoaded,
  userUnloaded,
  userClaimsFetched,
  userLazyClaims,
  userRefetchClaims,
  userRefetchNav
} = authSlice.actions;

export default authSlice.reducer;
